import { createFileRoute } from "@tanstack/react-router";
import { TestForm } from "@/components/admin/tests/TestForm";

export const Route = createFileRoute("/dashboard/admin/tests/new")({
  component: AdminNewTestPage,
});

function AdminNewTestPage() {
  return <TestForm />;
}
